import { MonitorStatus, monitorStatusBgCssClass } from '@fe/core';
import clsx from 'clsx';
import './MonitorStatusStripe.css';

export default function MonitorStatusStripe(props: { monitorStatus: MonitorStatus; className?: string }) {
    return <div className={clsx('monstat-stripe monstat-border', props.className, monitorStatusBgCssClass[props.monitorStatus])}></div>;
}
